import React from "react";
import { SideBar } from "../sidebar";
import DataTable from "react-data-table-component";
import i18n from "../../../i18n";
import { Spinner } from "react-bootstrap";
import { apiUrl } from "../../../constants/global";
import { HomeBanner } from "../../home/homeBanner";
import { getLoggedUser } from "../../../state/user";
import { getWalletSumary } from "../../../models/users";

const user = getLoggedUser();
export class WalletSummary extends React.Component {
  constructor() {
    super();
    this.state = {
      hide_menu: false,
      input: {},
      users: {},
      users_loading: false,
      customStyles: {
        headCells: {
          style: {
            fontWeight: "bold",
            backgroundColor: "#dadada",
            color: "#000000",
          },
        },
      },
      columns: [
        {
          name: i18n.t("id"),
          cell: (row) => <span>{row.id}</span>,
          width: "70px",
        },
        {
          name: i18n.t("name"),
          cell: (row) => <span>{row.name}</span>,
        },
        {
          name: i18n.t("username"),
          cell: (row) => <span>{row.username}</span>,
        },
        {
          name: i18n.t("email"),
          cell: (row) => <span>{row.email}</span>,
        },
        {
          name: i18n.t("phone"),
          cell: (row) => <span>{row.mobile}</span>,
        },
        {
          name: `${i18n.t("wallet")} ${i18n.t("amount")}`,
          cell: (row) => <span>{row.wallet_amount}</span>,
        },
        {
          name: `${i18n.t("hold")}  ${i18n.t("amount")}`,
          cell: (row) => <span>{row.hold_amount}</span>,
        },
      ],
    };

    this.handleChange = this.handleChange.bind(this);
    this.loadReportData = this.loadReportData.bind(this);
  }

  componentDidMount() {
    window.scrollTo(0, 0);
    this.loadReportData();
  }

  handleChange(event) {
    let input = this.state.input;
    input[event.target.name] = event.target.value;
    this.setState({ input });
  }

  async loadReportData() {
    this.setState({ users: {} });
    this.setState({ users_loading: true });
    const response = await getWalletSumary(this.state.input);
    if (response.data) {
      this.setState({ users_loading: false });
      this.setState({ users: response.data });
    }
  }

  render() {
    let users = this.state.users;
    return (
      <React.Fragment>
        <HomeBanner />

        <section className="sptb mt-5">
          <div className="container">
            <div className="row">
              <div
                className={
                  this.state.hide_menu
                    ? "d-none"
                    : "col-xl-3 col-lg-12 col-md-12"
                }
              >
                <SideBar />
              </div>
              <div
                className={
                  this.state.hide_menu
                    ? "col-xl-12 col-lg-12 col-md-12"
                    : "col-xl-9 col-lg-12 col-md-12"
                }
              >
                <form
                  id="UpdateProfile"
                  className="card mb-0"
                  autoComplete="off"
                >
                  <div className="card-header">
                    <h3 className="card-title">
                      <span
                        onClick={() => {
                          this.setState({ hide_menu: !this.state.hide_menu });
                        }}
                      >
                        <i
                          class={
                            this.state.hide_menu
                              ? "icon-size-actual"
                              : "icon-size-fullscreen"
                          }
                          aria-hidden="true"
                        ></i>
                        &nbsp;
                      </span>
                      {i18n.t("search")}
                    </h3>
                  </div>
                  <div className="card-body">
                    <div className="row">
                      <div className="col-sm-12 col-md-6">
                        <div className="form-group">
                          <label className="form-label">
                            {i18n.t("search")}
                          </label>
                          <div className="input-group">
                            <input
                              type="text"
                              className="form-control"
                              placeholder="Search by id, name, username or mobile"
                              name="search_string"
                              value={this.state.input.search_string}
                              onChange={this.handleChange}
                            />
                          </div>
                        </div>
                      </div>
                      <div className="col-sm-12 col-md-2">
                        <div className="form-group">
                          <label className="form-label">&nbsp;</label>
                          <button
                            type="button"
                            className="btn btn-primary btn-block"
                            onClick={this.loadReportData}
                          >
                            {i18n.t("search")}
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                </form>

                <hr />

                <div className="card mb-0">
                  <div className="card-header d-flex justify-content-between">
                    <h3 className="card-title">{i18n.t("result")}</h3>
                    {users.length > 0 && (
                      <div>
                        {/* <a
                          href={`${apiUrl}report/wallet_summary/pdf?${new URLSearchParams(
                            this.state.input
                          ).toString()}&auth=${user.token}`}
                          className="btn btn-dark"
                          target="_blank"
                          rel="noreferrer"
                        >
                          PDF
                        </a>{" "} */}
                        <a
                          href={`${apiUrl}report/wallet_summary/excel?${new URLSearchParams(
                            this.state.input
                          ).toString()}&auth=${user.token}`}
                          className="btn btn-dark"
                          target="_blank"
                          rel="noreferrer"
                        >
                          Excel
                        </a>
                      </div>
                    )}
                  </div>
                  <div className="card-body">
                    <div className="table-responsive ">
                      {this.state.users_loading && (
                        <div className="text-center">
                          <Spinner animation="border" />
                        </div>
                      )}
                      {!users.length && (
                        <div className="alert alert-danger">
                          {i18n.t("no_result")}
                        </div>
                      )}
                      {users.length > 0 && (
                        <div className="table-wrapper">
                          <DataTable
                            title=""
                            columns={this.state.columns}
                            data={users}
                            customStyles={this.state.customStyles}
                            highlightOnHover
                            pagination
                            paginationPerPage={15}
                            paginationRowsPerPageOptions={[15, 25, 50, 100]}
                            paginationComponentOptions={{
                              rowsPerPageText: "Users per page:",
                              rangeSeparatorText: i18n.t("out"),
                            }}
                          />
                        </div>
                      )}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
      </React.Fragment>
    );
  }
}
